var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'web-browser': _vm.auth.browser },attrs:{"id":"app"}},[_c('web-session-shell',[(_vm.auth.browser && _vm.auth.session)?_c('keep-alive',{key:_vm.auth.session.username,attrs:{"include":"WebHome"}},[_c('router-view')],1):_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }